import { Spin, SpinProps } from 'antd';

interface FullLoadingProps {
  indicator?: SpinProps['indicator'];
}

export const FullLoading = (props: FullLoadingProps) => {
  const { indicator } = props;

  return (
    <div className="w-full h-full flex items-center justify-center">
      <Spin spinning indicator={indicator} />
    </div>
  );
};
